// extracted by mini-css-extract-plugin
module.exports = {"safe_html":"styles_safe_html__FB5ud"};